import { ca } from '@cian/analytics';

import { type TSectionAnchor } from 'shared/settings/routes';
import { createDeveloperProduct } from 'shared/utils/analytics';

/**
 * @description Событие: клик по пункту навигации в шапке (якорь к секции лендинга).
 */
export function trackHeaderNavSectionClick(section: TSectionAnchor): void {
  ca('eventSite', {
    action: 'click_header_nav',
    category: 'Promo',
    label: section === '#' ? 'top' : section,
    name: 'oldevent',
    products: [createDeveloperProduct()],
  });
}
